import { deepFreeze } from '../../utils/misc_utils';

export const SupplierStatusFormEnum = deepFreeze({
    ACTIVATE: 'ACTIVATE',
    DEACTIVATE: 'DEACTIVATE'
});

export const SupplierStatusEnum = deepFreeze({
    ACTIVE: {
        value: 'ACTIVE',
        label: 'Aktywny'
    },
    INACTIVE: {
        value: 'INACTIVE',
        label: 'Nieaktywny'
    },
});
